<template>
    <div class="card">

        <div class="card-header d-flex justify-content-between align-items-center">
            Locations

            <span
                v-if="can_update_locations"
                @click="showAddLocationForm()"
                v-tooltip.bottom="'Add Location'"
                class="btn btn-sm btn-ghost-primary text-gray-500 cursor-pointer leading-none"
                data-test="addLocationsButton" >
                <i class="far fa-plus-circle text-base" />
            </span>
        </div>

        <slot name="alert"></slot>

    	<div v-if="showAddLocation" class="px-35 py-25 border-bottom">
            <div class="text-blue-700 font-weight-bold mb-2">New Location</div>
            
            <div class="form-group">
                <input class="form-control" v-model="form.label" placeholder="Name/Label" data-test="locationLabel">
            </div>

            <div class="row no-gutters mb-2">
                <div class="col-8 pr-1">   
                <input class="form-control" v-model="form.address" placeholder="Address" data-test="locationAddress">
            	</div>
            	<div class="col-4 pl-1">
                    <input class="form-control" v-model="form.address_2" placeholder="Address 2" data-test="locationAddress2">
                </div>
            </div>

            <div class="form-group">
                <input v-model="form.city" class="form-control mb-1" placeholder="City" data-test="locationCity">

	            <div class="d-flex align-items-center">
	                <div class="mr-2" style="width:100px;">    
                        <v-select
                            label="label"
                            :select-on-key-codes="[9, 13]"
                            :options="options.states"
                            :reduce="label => label.id"
                            v-model="form.state"
                            data-test="locationState"
                        />
	                </div>             
	                <input v-model="form.zip" class="form-control" placeholder="Zip" style="width:100px;" data-test="locationZip">
	            </div>
	        </div>

            <div class="row no-gutters mb-3">
                <div class="col pr-1">
                	<input class="form-control" v-model="form.phone" placeholder="Phone" data-test="locationPhone">
                </div>
                <div class="col pl-1">
                	<input class="form-control" v-model="form.fax" placeholder="Fax" data-test="locationFax">
                </div>
            </div>

            <div class="form-group text-right">
        		<button type="button" class="btn btn-ghost-secondary" @click="cancelLocation()">Cancel</button>
                <button type="button" class="btn btn-primary" @click="saveLocation()" data-test="saveLocationButton">Save</button>	
            </div>    
        </div>

		<ul class="list-group list-group-flush">
			<location-item
				v-for="location in all_locations"
				:key="location.id"
				:location="location"                     
				@update-location="updateLocation($event)"
				@delete-location="deleteLocation($event)"
			/>

            <div v-if="all_locations.length == 0 && !showAddLocation" class="text-center text-lg text-gray-500 p-3">
                No locations
            </div>
		</ul>

        <slot name="footer"></slot>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
	import LocationItem from './LocationItem';
    import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';

	export default {
        components: {
            LocationItem,
            HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form
        },

		props: ['locationable_id', 'locations', 'locationable_type', 'can_update_locations'],

		data() {
			return {
                showAddLocation: false,
				all_locations: this.locations,
				form: null,
			}
		},

		mounted() {
            this.$root.$on('set-primary-location', data => {
                axios.put('/api/locations/' + data + '/primary', { location_id: data }).then((locations) => {
                    this.all_locations = locations.data;
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        icon: 'success',
                        title: 'Primary location set',
                    });                     
                });
            }); 

            this.$root.$on('location-toggle-show-in-maps', location_id => {
                axios.put('/api/locations/' + location_id + '/toggle_show_in_maps')
                .then((response) => {
                    console.log("response", response);
                    var title = "Now showing location in maps";
                    if (!response.data.show_in_maps) {
                        var title = "Now hiding location in maps";
                    }
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        icon: 'success',
                        title: title,
                    });                     
                });
            }); 

		},

		methods: {
            showAddLocationForm() {
                this.showAddLocation = true;
                this.showForm();
            },

			showForm() {
	            this.form = new Form({
	                label:     '',
	                primary:   null,
	                address:   '',
	                address_2: '',
	                city:      '',
	                state:     '',
	                zip:       '',
	                phone:     '',
	                fax:       '',
	                locationable_type: 'App\\' + this.locationable_type,
	                locationable_id: this.locationable_id,
	            });

                //set new location to be primary if there are none.
                if (this.all_locations.length == 0) {
                    this.form.primary = true;
                }
                else {
                    this.form.primary = false;
                }                   				
			},

			saveLocation() {
				this.form.post('/api/locations')
					.then(({data}) => {
						this.all_locations.push(data);
						this.cancelLocation();	
					}
				);
			},

			cancelLocation() {
				this.showAddLocation = false;
			},


            deleteLocation(id) {
				this.all_locations.splice(this.locationIndex(id), 1);
            },

            updateLocation(data) {
            	console.log(data);
            	this.all_locations.splice(this.locationIndex(data.id), 1, data);
            },

            locationIndex(id) {
                return this.all_locations.findIndex((element) => {
                    return element.id === id;
                });            	
            },

		},

        computed: mapState(['options'])

		// watch: {
		// 	showAddLocation() {
		// 		if (this.showAddLocation === true) {
		// 			this.showForm();
		// 		}
		// 	}
		// }

	}

</script>